import React, { useEffect, useState, createContext, useContext } from 'react';
// DEV_BYPASS: Set to true to bypass the age gate during development
const DEV_BYPASS = true;
type AfterTideAuthContextType = {
  isVerified: boolean;
  verify: () => void;
  resetVerification: () => void;
};
const AfterTideAuthContext = createContext<AfterTideAuthContextType | undefined>(undefined);
export const AfterTideAuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isVerified, setIsVerified] = useState<boolean>(() => {
    if (DEV_BYPASS) return true;
    const saved = localStorage.getItem('aftertide_verified');
    return saved === 'true';
  });
  useEffect(() => {
    if (!DEV_BYPASS) {
      localStorage.setItem('aftertide_verified', isVerified.toString());
    }
  }, [isVerified]);
  const verify = () => {
    setIsVerified(true);
  };
  const resetVerification = () => {
    setIsVerified(false);
  };
  return <AfterTideAuthContext.Provider value={{
    isVerified,
    verify,
    resetVerification
  }} data-id="element-4120" data-mp="2eugcucezaxv1">
      {children}
    </AfterTideAuthContext.Provider>;
};
export const useAfterTideAuth = (): AfterTideAuthContextType => {
  const context = useContext(AfterTideAuthContext);
  if (context === undefined) {
    throw new Error('useAfterTideAuth must be used within an AfterTideAuthProvider');
  }
  return context;
};